import { AppBar, Box, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UserWidget } from 'features/auth';
import { LanguageSwitch, TenantLogoType } from 'shared/components';

import AppTitle from '../AppTitle';
import ContactsLink from '../ContactsLink';
import CookiesButton from '../CookiesButton';
import FallbackLink from '../FallbackLink';
import ReportProblemButton from '../ReportProblemButton';
import LinkToPrivacy from '../LinkToPrivacy';
import Spacer from '../Spacer';
import NavigationTabs from './NavigationTabs';

export default function NavigationDesktop() {
    return (
        <>
            <AppBar position="fixed">
                <HeaderContent>
                    <LogoSection>
                        <TenantLogoType />
                        <AppTitle />
                    </LogoSection>

                    <ToolbarRightAnchorContainer>
                        <FallbackLink />
                        <ContactsLink />
                        <LinkToPrivacy />
                        <CookiesButton />
                        <ReportProblemButton />
                        <LanguageSwitch compact />
                        <UserWidget />
                    </ToolbarRightAnchorContainer>
                        
                </HeaderContent>
        
                <NavigationTabs />
            </AppBar>

            <Spacer />
        </>
    );
}

const ToolbarRightAnchorContainer = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(4),
    gap: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',

    'a, p': {
        fontSize: '0.8rem'
    }
}));

const HeaderContent = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 6)
    }
}));

const LogoSection = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4)
}));
